module.exports = __webpack_public_path__ + "img/exportXjmmWhite.590296d4.svg";